<template>
  <div>
    <Breadcrumb />
    <el-card class="box-card mt-20">
      <div slot="header" class="clearfix">
        <span>用户信息维护</span>
      </div>
      <el-form
        ref="userForm"
        :model="userInfo"
        :rules="rules"
        class="add-form"
        :label-position="labelPosition"
        label-width="100px"
      >
        <div class="add-form-item">
          <el-form-item label="角色：" prop="roleId">
            <el-select v-model="userInfo.roleId" placeholder="请选择">
              <el-option
                v-for="item in roleOptions"
                :key="item.id"
                :label="item.roleName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label=" 账号：">
            <span>{{ userInfo.username }}</span>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label=" 工号：">
            <span>{{ userInfo.username }}</span>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label="姓名：" prop="realName">
            <el-input v-model="userInfo.realName"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入25个字符</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="业务岗位：">
            <el-input v-model="userInfo.businessPosition"></el-input>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label="状态：">
            <el-radio-group v-model="userInfo.userState">
              <el-radio :label="'1'">正常使用</el-radio>
              <el-radio :label="'0'">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <br />
        <el-form-item>
          <el-button type="primary" @click="submit">确定</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelPosition: "left",
      roleOptions: [],
      userInfo: {
        id: "",
        roleId: "",
        username: "",
        realName: "",
        businessPosition: "",
        userState: "1"
      },
      rules: {
        realName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          },
          {
            max: 20,
            message: "最多输入20个字符",
            trigger: "change"
          }
        ],
        roleId: [
          { required: true, message: "请选择角色信息", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getRoleInfoList() {
      let _this = this;
      let param = {
        url: "/api/role/getRoleInfoList"
      };

      _this.$store.dispatch("getRoleInfoList", param).then(() => {
        _this.roleOptions = _this.$store.state.system.roleOptions;
      });
    },
    getUserInfoById(id) {
      let _this = this;
      let param = {
        url: "/api/system/user/getUserInfoById",
        params: {
          id: id
        }
      };

      _this.$store.dispatch("getUserInfoById", param).then(() => {
        _this.userInfo = _this.$store.state.system.userInfo;
      });
    },
    submit() {
      let _this = this;
      _this.$refs.userForm.validate(isPass => {
        if (isPass) {
          let param = {
            url: "/api/system/user/updateUserInfo",
            params: {
              id: _this.userInfo.id,
              roleId: _this.userInfo.roleId,
              realName: _this.userInfo.realName,
              businessPosition: _this.userInfo.businessPosition,
              userState: _this.userInfo.userState
            }
          };

          _this.$Api
            .post(param.url, param.params)
            .then(response => {
              if (response.status === 200) {
                _this.$message({
                  message: "用户信息维护成功",
                  type: "success"
                });
                this.$router.push({
                  name: "user"
                });
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(err => {});
        } else {
          _this.$message({
            message: "请完善用户信息!",
            type: "warning"
          });
        }
      });
    }
  },
  created() {
    let _this = this;
    let id = this.$route.params.id;
    if (id !== null && id !== "" && id !== undefined) {
      _this.getUserInfoById(id);
    }
    _this.getRoleInfoList();
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
  width: 700px
  display: flex
  .el-form-item
    width: 460px
  .validate
    height: 40px
    line-height: 40px
    font-size: 14px
    color: #E6A23C
</style>
